import {
  CaptchaResponse,
  CaptchaService,
} from '$core/services/captcha.service';
import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  ElementRef,
  forwardRef,
  Injector,
  OnInit,
  Type,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  NgControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss'],
  providers: [
    [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CaptchaComponent),
        multi: true,
      },
    ],
  ],
})
export class CaptchaComponent implements ControlValueAccessor, OnInit {
  public readonly faSync = faSync;
  public value = '';
  public data: CaptchaResponse;
  public isLoading = false;
  public isError = false;
  public ngControl: NgControl;
  @ViewChild('inputEl', { static: false })
  public inputElRef: ElementRef<HTMLInputElement>;

  public get inputEl() {
    return this.inputElRef && this.inputElRef.nativeElement;
  }

  constructor(
    private injector: Injector,
    private captchaService: CaptchaService
  ) {}

  public ngOnInit() {
    this.ngControl = this.injector.get(NgControl as Type<NgControl>);
    this.load().subscribe();
  }

  private load() {
    this.data = null;
    this.isLoading = true;
    this.isError = false;

    return this.captchaService.getCaptcha().pipe(
      tap(
        (res) => {
          this.isLoading = false;
          this.data = res;
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.isError = true;
        }
      )
    );
  }

  public reload(withFocus?: boolean) {
    this.load().subscribe((res) => {
      if (withFocus) {
        setTimeout(() => this.inputEl && this.inputEl.focus(), 0);
      }
    });

    const errors = this.ngControl && { ...this.ngControl.control.errors };
    this.updateValue(null);
    if (errors) {
      this.ngControl.control.setErrors(errors);
    }
  }

  private onChange = (value: any) => {};
  private onTouched = () => {};

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  public writeValue(outsideValue: any) {
    this.value = outsideValue;
  }

  public updateValue(insideValue: any) {
    this.value = insideValue;
    this.onChange(insideValue);
    this.onTouched();
  }
}
